

export function obterLogo() {
    
    const tipo_acesso: string = localStorage.getItem('tipo-acesso');
    const dados_local_storage = JSON?.parse?.(localStorage?.getItem('Itens'))?.[0] ?? [];

    const acesso_cliente = dados_local_storage?.['acessoConta'];
    const cod_conta_ou_cod_cliente = tipo_acesso === 'conta' ? JSON.parse(localStorage.getItem('conta')) : JSON.parse(localStorage.getItem('cod-cliente'))
    const lista_clientes = tipo_acesso === 'conta' ? acesso_cliente['contas'] : acesso_cliente['clientes'];

    const dadosLogoLocal = (lista_clientes ?? []).find((item) => item.cod === cod_conta_ou_cod_cliente)
    
    if (dadosLogoLocal) {
        const logo = dadosLogoLocal?.['logo']
        return logo;
    }

    return null;
}